'use strict';

/**
 *
 * @name: nownessApp.utility
 *
 */

 /**
 *
 * Styles
 *
 */

import './about/utility-about-contributor.index.scss'

import UtilityConfig from './utility.config';

const UtilityModule = angular
  .module('nownessApp.utility', [
    'ui.router',
    'nownessApp.analytics'
  ])
  .config(UtilityConfig);

export default UtilityModule.name;



// WEBPACK FOOTER //
// ./app/pages/utility/utility.module.js